module.exports = __webpack_public_path__ + "img/confirm_btn.5f07b689.png";